"use strict"; // Copyright 2021 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var _regeneratorRuntime = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _classCallCheck = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _get = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/get");

var _inherits = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DownscopedClient = exports.EXPIRATION_TIME_OFFSET = exports.MAX_ACCESS_BOUNDARY_RULES_COUNT = void 0;

var stream = require("stream");

var authclient_1 = require("./authclient");

var sts = require("./stscredentials");
/**
 * The required token exchange grant_type: rfc8693#section-2.1
 */


var STS_GRANT_TYPE = 'urn:ietf:params:oauth:grant-type:token-exchange';
/**
 * The requested token exchange requested_token_type: rfc8693#section-2.1
 */

var STS_REQUEST_TOKEN_TYPE = 'urn:ietf:params:oauth:token-type:access_token';
/**
 * The requested token exchange subject_token_type: rfc8693#section-2.1
 */

var STS_SUBJECT_TOKEN_TYPE = 'urn:ietf:params:oauth:token-type:access_token';
/** The STS access token exchange end point. */

var STS_ACCESS_TOKEN_URL = 'https://sts.googleapis.com/v1/token';
/**
 * The maximum number of access boundary rules a Credential Access Boundary
 * can contain.
 */

exports.MAX_ACCESS_BOUNDARY_RULES_COUNT = 10;
/**
 * Offset to take into account network delays and server clock skews.
 */

exports.EXPIRATION_TIME_OFFSET = 5 * 60 * 1000;
/**
 * Defines a set of Google credentials that are downscoped from an existing set
 * of Google OAuth2 credentials. This is useful to restrict the Identity and
 * Access Management (IAM) permissions that a short-lived credential can use.
 * The common pattern of usage is to have a token broker with elevated access
 * generate these downscoped credentials from higher access source credentials
 * and pass the downscoped short-lived access tokens to a token consumer via
 * some secure authenticated channel for limited access to Google Cloud Storage
 * resources.
 */

var DownscopedClient =
/*#__PURE__*/
function (_authclient_1$AuthCli) {
  _inherits(DownscopedClient, _authclient_1$AuthCli);

  /**
   * Instantiates a downscoped client object using the provided source
   * AuthClient and credential access boundary rules.
   * To downscope permissions of a source AuthClient, a Credential Access
   * Boundary that specifies which resources the new credential can access, as
   * well as an upper bound on the permissions that are available on each
   * resource, has to be defined. A downscoped client can then be instantiated
   * using the source AuthClient and the Credential Access Boundary.
   * @param authClient The source AuthClient to be downscoped based on the
   *   provided Credential Access Boundary rules.
   * @param credentialAccessBoundary The Credential Access Boundary which
   *   contains a list of access boundary rules. Each rule contains information
   *   on the resource that the rule applies to, the upper bound of the
   *   permissions that are available on that resource and an optional
   *   condition to further restrict permissions.
   * @param additionalOptions Optional additional behavior customization
   *   options. These currently customize expiration threshold time and
   *   whether to retry on 401/403 API request errors.
   * @param quotaProjectId Optional quota project id for setting up in the
   *   x-goog-user-project header.
   */
  function DownscopedClient(authClient, credentialAccessBoundary, additionalOptions, quotaProjectId) {
    var _this;

    _classCallCheck(this, DownscopedClient);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DownscopedClient).call(this));
    _this.authClient = authClient;
    _this.credentialAccessBoundary = credentialAccessBoundary; // Check 1-10 Access Boundary Rules are defined within Credential Access
    // Boundary.

    if (credentialAccessBoundary.accessBoundary.accessBoundaryRules.length === 0) {
      throw new Error('At least one access boundary rule needs to be defined.');
    } else if (credentialAccessBoundary.accessBoundary.accessBoundaryRules.length > exports.MAX_ACCESS_BOUNDARY_RULES_COUNT) {
      throw new Error('The provided access boundary has more than ' + "".concat(exports.MAX_ACCESS_BOUNDARY_RULES_COUNT, " access boundary rules."));
    } // Check at least one permission should be defined in each Access Boundary
    // Rule.


    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = credentialAccessBoundary.accessBoundary.accessBoundaryRules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var rule = _step.value;

        if (rule.availablePermissions.length === 0) {
          throw new Error('At least one permission should be defined in access boundary rules.');
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    _this.stsCredential = new sts.StsCredentials(STS_ACCESS_TOKEN_URL);
    _this.cachedDownscopedAccessToken = null; // As threshold could be zero,
    // eagerRefreshThresholdMillis || EXPIRATION_TIME_OFFSET will override the
    // zero value.

    if (typeof (additionalOptions === null || additionalOptions === void 0 ? void 0 : additionalOptions.eagerRefreshThresholdMillis) !== 'number') {
      _this.eagerRefreshThresholdMillis = exports.EXPIRATION_TIME_OFFSET;
    } else {
      _this.eagerRefreshThresholdMillis = additionalOptions.eagerRefreshThresholdMillis;
    }

    _this.forceRefreshOnFailure = !!(additionalOptions === null || additionalOptions === void 0 ? void 0 : additionalOptions.forceRefreshOnFailure);
    _this.quotaProjectId = quotaProjectId;
    return _this;
  }
  /**
   * Provides a mechanism to inject Downscoped access tokens directly.
   * The expiry_date field is required to facilitate determination of the token
   * expiration which would make it easier for the token consumer to handle.
   * @param credentials The Credentials object to set on the current client.
   */


  _createClass(DownscopedClient, [{
    key: "setCredentials",
    value: function setCredentials(credentials) {
      if (!credentials.expiry_date) {
        throw new Error('The access token expiry_date field is missing in the provided ' + 'credentials.');
      }

      _get(_getPrototypeOf(DownscopedClient.prototype), "setCredentials", this).call(this, credentials);

      this.cachedDownscopedAccessToken = credentials;
    }
  }, {
    key: "getAccessToken",
    value: function getAccessToken() {
      return _regeneratorRuntime.async(function getAccessToken$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!this.cachedDownscopedAccessToken || this.isExpired(this.cachedDownscopedAccessToken))) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return _regeneratorRuntime.awrap(this.refreshAccessTokenAsync());

            case 3:
              return _context.abrupt("return", {
                token: this.cachedDownscopedAccessToken.access_token,
                expirationTime: this.cachedDownscopedAccessToken.expiry_date,
                res: this.cachedDownscopedAccessToken.res
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    }
    /**
     * The main authentication interface. It takes an optional url which when
     * present is the endpoint being accessed, and returns a Promise which
     * resolves with authorization header fields.
     *
     * The result has the form:
     * { Authorization: 'Bearer <access_token_value>' }
     */

  }, {
    key: "getRequestHeaders",
    value: function getRequestHeaders() {
      var accessTokenResponse, headers;
      return _regeneratorRuntime.async(function getRequestHeaders$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _regeneratorRuntime.awrap(this.getAccessToken());

            case 2:
              accessTokenResponse = _context2.sent;
              headers = {
                Authorization: "Bearer ".concat(accessTokenResponse.token)
              };
              return _context2.abrupt("return", this.addSharedMetadataHeaders(headers));

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "request",
    value: function request(opts, callback) {
      if (callback) {
        this.requestAsync(opts).then(function (r) {
          return callback(null, r);
        }, function (e) {
          return callback(e, e.response);
        });
      } else {
        return this.requestAsync(opts);
      }
    }
    /**
     * Authenticates the provided HTTP request, processes it and resolves with the
     * returned response.
     * @param opts The HTTP request options.
     * @param retry Whether the current attempt is a retry after a failed attempt.
     * @return A promise that resolves with the successful response.
     */

  }, {
    key: "requestAsync",
    value: function requestAsync(opts) {
      var retry,
          response,
          requestHeaders,
          res,
          statusCode,
          isReadableStream,
          isAuthErr,
          _args3 = arguments;
      return _regeneratorRuntime.async(function requestAsync$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              retry = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : false;
              _context3.prev = 1;
              _context3.next = 4;
              return _regeneratorRuntime.awrap(this.getRequestHeaders());

            case 4:
              requestHeaders = _context3.sent;
              opts.headers = opts.headers || {};

              if (requestHeaders && requestHeaders['x-goog-user-project']) {
                opts.headers['x-goog-user-project'] = requestHeaders['x-goog-user-project'];
              }

              if (requestHeaders && requestHeaders.Authorization) {
                opts.headers.Authorization = requestHeaders.Authorization;
              }

              _context3.next = 10;
              return _regeneratorRuntime.awrap(this.transporter.request(opts));

            case 10:
              response = _context3.sent;
              _context3.next = 27;
              break;

            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](1);
              res = _context3.t0.response;

              if (!res) {
                _context3.next = 26;
                break;
              }

              statusCode = res.status; // Retry the request for metadata if the following criteria are true:
              // - We haven't already retried.  It only makes sense to retry once.
              // - The response was a 401 or a 403
              // - The request didn't send a readableStream
              // - forceRefreshOnFailure is true

              isReadableStream = res.config.data instanceof stream.Readable;
              isAuthErr = statusCode === 401 || statusCode === 403;

              if (!(!retry && isAuthErr && !isReadableStream && this.forceRefreshOnFailure)) {
                _context3.next = 26;
                break;
              }

              _context3.next = 23;
              return _regeneratorRuntime.awrap(this.refreshAccessTokenAsync());

            case 23:
              _context3.next = 25;
              return _regeneratorRuntime.awrap(this.requestAsync(opts, true));

            case 25:
              return _context3.abrupt("return", _context3.sent);

            case 26:
              throw _context3.t0;

            case 27:
              return _context3.abrupt("return", response);

            case 28:
            case "end":
              return _context3.stop();
          }
        }
      }, null, this, [[1, 13]]);
    }
    /**
     * Forces token refresh, even if unexpired tokens are currently cached.
     * GCP access tokens are retrieved from authclient object/source credential.
     * Then GCP access tokens are exchanged for downscoped access tokens via the
     * token exchange endpoint.
     * @return A promise that resolves with the fresh downscoped access token.
     */

  }, {
    key: "refreshAccessTokenAsync",
    value: function refreshAccessTokenAsync() {
      var _a, subjectToken, stsCredentialsOptions, stsResponse, sourceCredExpireDate, expiryDate;

      return _regeneratorRuntime.async(function refreshAccessTokenAsync$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _regeneratorRuntime.awrap(this.authClient.getAccessToken());

            case 2:
              subjectToken = _context4.sent.token;
              // Construct the STS credentials options.
              stsCredentialsOptions = {
                grantType: STS_GRANT_TYPE,
                requestedTokenType: STS_REQUEST_TOKEN_TYPE,
                subjectToken: subjectToken,
                subjectTokenType: STS_SUBJECT_TOKEN_TYPE
              }; // Exchange the source AuthClient access token for a Downscoped access
              // token.

              _context4.next = 6;
              return _regeneratorRuntime.awrap(this.stsCredential.exchangeToken(stsCredentialsOptions, undefined, this.credentialAccessBoundary));

            case 6:
              stsResponse = _context4.sent;

              /**
               * The STS endpoint will only return the expiration time for the downscoped
               * access token if the original access token represents a service account.
               * The downscoped token's expiration time will always match the source
               * credential expiration. When no expires_in is returned, we can copy the
               * source credential's expiration time.
               */
              sourceCredExpireDate = ((_a = this.authClient.credentials) === null || _a === void 0 ? void 0 : _a.expiry_date) || null;
              expiryDate = stsResponse.expires_in ? new Date().getTime() + stsResponse.expires_in * 1000 : sourceCredExpireDate; // Save response in cached access token.

              this.cachedDownscopedAccessToken = {
                access_token: stsResponse.access_token,
                expiry_date: expiryDate,
                res: stsResponse.res
              }; // Save credentials.

              this.credentials = {};
              Object.assign(this.credentials, this.cachedDownscopedAccessToken);
              delete this.credentials.res; // Trigger tokens event to notify external listeners.

              this.emit('tokens', {
                refresh_token: null,
                expiry_date: this.cachedDownscopedAccessToken.expiry_date,
                access_token: this.cachedDownscopedAccessToken.access_token,
                token_type: 'Bearer',
                id_token: null
              }); // Return the cached access token.

              return _context4.abrupt("return", this.cachedDownscopedAccessToken);

            case 15:
            case "end":
              return _context4.stop();
          }
        }
      }, null, this);
    }
    /**
     * Returns whether the provided credentials are expired or not.
     * If there is no expiry time, assumes the token is not expired or expiring.
     * @param downscopedAccessToken The credentials to check for expiration.
     * @return Whether the credentials are expired or not.
     */

  }, {
    key: "isExpired",
    value: function isExpired(downscopedAccessToken) {
      var now = new Date().getTime();
      return downscopedAccessToken.expiry_date ? now >= downscopedAccessToken.expiry_date - this.eagerRefreshThresholdMillis : false;
    }
  }]);

  return DownscopedClient;
}(authclient_1.AuthClient);

exports.DownscopedClient = DownscopedClient;